import React, { Component } from "react";
// import { thisExpression } from "@babel/types";
 
class Header extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            showNav:false,
           
        };
        
    }
    componentWillMount()
    {
        if(localStorage.getItem('userData'))
        {
            this.setState({
                showNav:true
            })
        }
    }
  render() {
    let image = this.props.titleImage;
    let showNav = this.state.showNav;
    return (
        <header className="c-main-header">
            <div className="container">
                <div className="header-content">
                    {
                        showNav &&
                        <div className="h-menu">
                            <div className="nav-icon js-sideMenu">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                    }
                    <div className="page-title">
                        <div className="title-icons">
                        {image ? <img src={require(`../assets/img/icons/${image}`)} alt="" />  : null}
                        
                            
                        </div>
                        <div className="title-name">
                            <h1>{this.props.title}</h1>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
  }
}

export default Header;